module.exports = __webpack_public_path__ + "static/media/A32.b784939b.png";